module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-year",
    class: {
      'white-theme': _vm.whiteTheme
    }
  }, [(_vm.schoolYears.length > 1) ? _c('select', {
    staticClass: "school-year__select",
    domProps: {
      "value": _vm.activeSchoolYear.id
    },
    on: {
      "change": function($event) {
        return _vm.setActiveSchoolYear($event.target.value)
      }
    }
  }, _vm._l((_vm.schoolYears), function(year) {
    return _c('option', {
      key: year.id,
      domProps: {
        "value": year.id
      }
    }, [_vm._v(_vm._s(year.name))])
  }), 0) : _c('div', {
    staticClass: "school-year__active"
  }, [_c('p', [_vm._v(_vm._s(_vm.activeSchoolYear.name))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e014dd16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/School/ChangeSchoolYear.vue
// module id = 2143
// module chunks = 1